// Smooth momentum scroll via Lenis — gives the premium cinematic feel.
import { useEffect } from 'react';
import Lenis from 'lenis';

export const useLenis = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.4,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            touchMultiplier: 1.2,
            wheelMultiplier: 1.0,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Hook up anchor clicks so smooth scroll works with hash navigation
        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const id = anchor.getAttribute('href');
            if (!id || id === '#') return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -40, duration: 1.6 });
            }
        };
        document.addEventListener('click', onClick);

        return () => {
            document.removeEventListener('click', onClick);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
};
